module.exports = __webpack_public_path__ + "db8130750e49aa9880a65c6394a0f3a5.png";